import React from 'react';

interface Props {
  width?: number;
  color?: string;
}

const Picture = ({ width = 20, color = '#333745' }: Props) => (
  <svg width={width} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.75" y="0.75" width="15.5" height="15.5" rx="1.25" stroke={color} strokeWidth="1.5" />
    <path
      d="M1 5V17C1 18.1046 1.89543 19 3 19H15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3885 10.1218C8.58433 9.80846 9.04067 9.80846 9.2365 10.1218L10.7229 12.5H6.90212L8.3885 10.1218Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8653 7.13746C13.0495 6.76894 13.5755 6.76894 13.7597 7.13746L16.441 12.5H13.3125H10.184L11.791 9.28611L12.8653 7.13746Z"
      fill="#EDEFF3"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8.8125" cy="5.6875" r="1.1875" stroke={color} />
  </svg>
);

export default Picture;
